export enum ShareFireOutbreakAlertEnum {
	WHATSAPP = 'whatsapp',
}
